// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface ExtractDatasetOutput
 */
export interface ExtractDatasetOutput {
  /**
   *
   */
  file?: RanaFile;
}

/**
 * Check if a given object implements the ExtractDatasetOutput interface.
 */
export function instanceOfExtractDatasetOutput(value: object): value is ExtractDatasetOutput {
  return true;
}

export function ExtractDatasetOutputFromJSON(json: any): ExtractDatasetOutput {
  return ExtractDatasetOutputFromJSONTyped(json, false);
}

export function ExtractDatasetOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractDatasetOutput {
  if (json == null) {
    return json;
  }
  return {
    file: json["file"] == null ? undefined : RanaFileFromJSON(json["file"]),
  };
}

export function ExtractDatasetOutputToJSON(json: any): ExtractDatasetOutput {
  return ExtractDatasetOutputToJSONTyped(json, false);
}

export function ExtractDatasetOutputToJSONTyped(
  value?: ExtractDatasetOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    file: RanaFileToJSON(value["file"]),
  };
}
